<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getProducts } from "../../api"

    import ProductListItem from "./ProductListItem.svelte"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { login, productListCache } from "../../store"
    import { equal } from "../../utils"

    export let filter
    export let hideMore: boolean = false

    export let sort
    export let limit = 12
    export let count = 0
    export let currentCount = 0

    let offset = 0
    let hasMore = false
    let loading = false

    export let products: Product[] = []

    const setProducts = (_products, append = true) => {
        if (append) {
            products = [...products, ..._products.data]
        } else {
            products = _products.data
        }
        count = _products.count
        currentCount = products.length
        hasMore = products.length < count
        loading = false
    }

    const load = async () => {
        hasMore = false
        loading = true
        let _filterChanged = filterChanged

        // is dealer is logged in hide no_dealers products
        if ($login) {
            filter.no_dealers = {
                $ne: true,
            }
        }

        const cacheKey = JSON.stringify({ filter, sort })

        if (offset == 0) {
            // try to use cache
            let _p = $productListCache.get(cacheKey)
            if (_p) {
                setProducts(_p, false)
                offset = products.length - limit
                return
            }
        }

        const _products = await getProducts(filter, sort, limit, offset)
        if (filterChanged != _filterChanged) {
            // filter changed while query in progress, so ignore products
        } else {
            setProducts(_products)
            $productListCache.put(cacheKey, {
                data: products,
                count: _products.count,
            })
        }
    }

    let prevFilter
    let prevSort

    let filterChanged = 0

    $: {
        if (filter && sort && (!equal(prevFilter, filter) || prevSort != sort)) {
            count = 0
            offset = 0
            hasMore = false
            products = []
            if (filter && sort) {
                filterChanged++
                prevFilter = filter
                prevSort = sort
                load()
            }
        }
    }
</script>

<!-- Product List -->
<div class="products">
    {#each products as product (product.id)}
        <ProductListItem {product} />
    {/each}
    {#if loading}
        <MiniLoader />
    {/if}
</div>

<!-- Load more Button -->
{#if hasMore && !hideMore}
    <div class="center_btn">
        <button
            class="btn btn-secondary"
            on:click="{(e) => {
                e.preventDefault()
                offset += limit
                load()
            }}">{$_("product.load-more")}</button
        >
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    .products {
        .flex();
        flex-wrap: wrap;
        margin: 20px -20px 40px -20px;
        overflow: hidden;
        :global {
            .product {
                width: 100%;
                @media @mobile {
                    width: 50%;
                }
                @media @tablet {
                    width: 33.333333%;
                }
                @media @desktop {
                    width: 25%;
                }
            }
        }
    }
</style>
